import InfosClientPage from "./InfosClientPage";
import ListClient from "./ListClient";
export {
    InfosClientPage,
    ListClient
}